import './datepicker/datepicker-fr-CA.js';
import './parsley/fr.extra.js';
import './parsley/fr.js';
import './languageformat/languageformat.js';
